import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import LoginHeatmap from '../components/LoginHeatmap';
import Spinner from '../components/Spinner';
import { fetchActiveUsersByDayAndWeek } from '../services/api';

const TotalLoginsByDayAndHour = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const loadData = async () => {
            try {
                setLoading(true);
                setError(null);
                const response = await fetchActiveUsersByDayAndWeek();
                setData(response);
            } catch (err) {
                console.error('Error fetching login data:', err);
                setError('Failed to load data. Please try again later.');
            } finally {
                setLoading(false);
            }
        };

        loadData();
    }, []);

    return (
        <div className="min-h-screen bg-gray-50">
            <Header pageTitle="On a given day of the week and hour, how many users log in on average? (Time in EDT)" />
            
            <div className="p-4 max-w-[1600px] mx-auto">
                <div className="bg-white rounded-lg shadow-md p-4 md:p-6">
                    <div className="mb-6">
                        <h2 className="text-xl font-semibold text-gray-800">
                            Average Logins by Day of Week and Hour
                        </h2>
                    </div>

                    {loading && (
                        <div className="flex justify-center items-center py-12">
                            <Spinner />
                        </div>
                    )}

                    {error && (
                        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-md">
                            {error}
                        </div>
                    )}

                    {!loading && !error && (
                        <LoginHeatmap data={data} />
                    )}
                </div>
            </div>
        </div>
    );
};

export default TotalLoginsByDayAndHour;